<template>
    <div v-if="!hash">
        <form-header
            title="Ansuchen"
            subtitle="Talenteprogramm ohne Strukturförderung"
            tag=""
        ></form-header>

        <ValidationObserver ref="form">
            <div id="printform">
                <div class="bg-primary">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <transition name="fade">
                            <div
                                class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                                v-show="formbehaviour.alertrequired"
                            >
                                <div class="md:grid md:grid-cols-1 md:gap-3">
                                    <div class="md:col-span-1">
                                        <h3 class="leading-3">
                                            Bitte überprüfen Sie Ihre Eingabe!
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <form-section
                            title="Angaben zur Schülerin/zum Schüler"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                        >
                            <drop-down
                                :values="[
                                    { id: 865250001, name: 'Herr' },
                                    { id: 865250000, name: 'Frau' },
                                ]"
                                v-model="ansuchen.schueler.anrede"
                                label="Anrede"
                                rules="required"
                                columns="2"
                            ></drop-down>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.schueler.vorname"
                                label="Vorname"
                                columns="3"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.nachname"
                                label="Nachname"
                                columns="3"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.geburtsdatum"
                                label="Geburtsdatum"
                                placeholder="z.B. 14.03.2008"
                                columns="2"
                                rules="required|date"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.strasse"
                                label="Straße, Hausnummer"
                                columns="5"
                                tooltip="bitte die Meldeadresse angeben"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.plz"
                                label="Postleitzahl"
                                columns="2"
                                tooltip="bitte die Meldeadresse angeben"
                                rules="required|numeric|length:4"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.ort"
                                label="Ort"
                                columns="4"
                                tooltip="bitte die Meldeadresse angeben"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.email"
                                rules="required|email"
                                label="E-Mail"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.schueler.telefon"
                                rules="required|numeric"
                                label="Telefonnummer"
                                columns="3"
                            ></text-input>
                        </form-section>

                        <form-section
                            title="Angaben zur Musikschule"
                            subtitle="Bitte wählen Sie Ihre Schule aus."
                        >
                            <drop-down
                                :values="formdata.musikschulen"
                                v-model="ansuchen.musikschuleId"
                                label="Musikschule"
                                :rules="
                                    ansuchen.anderemusikschule ? '' : 'required'
                                "
                                columns="5"
                            ></drop-down>
                            <text-input
                                v-model="ansuchen.anderemusikschule"
                                label="oder andere Musikschule"
                                columns="3"
                                :rules="
                                    ansuchen.musikschuleId ? '' : 'required'
                                "
                            ></text-input>
                        </form-section>

                        <form-section
                            title="Leistungsnachweis Wettbewerbsteilnahme"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                        >
                            <drop-down
                                :values="formdata.wettbewerbe"
                                v-model="ansuchen.wettbewerb.wettbewerbId"
                                label="Wettbewerb"
                                :rules="
                                    ansuchen.wettbewerb.andererwettbewerb
                                        ? ''
                                        : 'required'
                                "
                                columns="3"
                            ></drop-down>
                            <drop-down
                                :values="formdata.altersgruppen"
                                v-model="ansuchen.wettbewerb.altersgruppeId"
                                label="Altersgruppe"
                                :valdisabled="
                                    !formdata.altersgruppen ||
                                        formdata.altersgruppen.length == 0
                                "
                                :rules="
                                    ansuchen.wettbewerb.andererwettbewerb
                                        ? ''
                                        : 'required'
                                "
                                columns="3"
                            ></drop-down>
                            <text-input
                                v-model="ansuchen.wettbewerb.andererwettbewerb"
                                label="oder anderer Wettbewerb und Altersgruppe"
                                columns="4"
                                :rules="
                                    ansuchen.wettbewerb.wettbewerbId
                                        ? ''
                                        : 'required'
                                "
                            ></text-input>
                            <drop-down
                                :values="[
                                    { id: 180730000, name: 'SolistIn' },
                                    { id: 180730001, name: 'Ensemble' },
                                ]"
                                v-model="ansuchen.wettbewerb.antrittals"
                                label="Antritt als"
                                rules="required"
                                columns="2"
                            ></drop-down>
                            <text-input
                                v-show="
                                    ansuchen.wettbewerb.antrittals == 180730001
                                "
                                v-model="ansuchen.wettbewerb.ensemblename"
                                label="Ensemblename"
                                rules="required"
                                :valdisabled="
                                    ansuchen.wettbewerb.antrittals != 180730001
                                "
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.wettbewerb.ergebnis"
                                label="Wettbewerbsergebnis"
                                rules="required"
                                columns="4"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.wettbewerb.vorspielAm"
                                label="Datum des Vorspiels"
                                placeholder="z.B. 21.09.2019"
                                rules="date"
                                columns="2"
                            ></text-input>
                        </form-section>

                        <form-section
                            title="Angaben zur Instrument"
                            subtitle="Bitte wählen Sie ein Instrument aus."
                        >
                            <drop-down
                                :values="formdata.faecher"
                                v-model="ansuchen.instrumentId"
                                label="Instrument"
                                :valdisabled="
                                    !formdata.faecher ||
                                        formdata.faecher.length == 0
                                "
                                rules="required"
                                columns="4"
                            ></drop-down>
                        </form-section>

                        <form-section
                            title="Angaben zum/zur Erziehungsberechtigten"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                            v-show="brauchterziehungsberechtigten"
                        >
                            <drop-down
                                :values="[
                                    { id: 865250001, name: 'Herr' },
                                    { id: 865250000, name: 'Frau' },
                                ]"
                                v-model="ansuchen.erziehungsberechtigter.anrede"
                                label="Anrede"
                                :valdisabled="!brauchterziehungsberechtigten"
                                rules="required"
                                columns="2"
                            ></drop-down>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.erziehungsberechtigter.prefix"
                                label="Titel (vorangestellt)"
                                columns="2"
                            ></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="
                                    ansuchen.erziehungsberechtigter.vorname
                                "
                                label="Vorname"
                                :valdisabled="!brauchterziehungsberechtigten"
                                rules="required"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="
                                    ansuchen.erziehungsberechtigter.nachname
                                "
                                label="Nachname"
                                :valdisabled="!brauchterziehungsberechtigten"
                                rules="required"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.erziehungsberechtigter.suffix"
                                label="Titel (nachgestellt)"
                                columns="2"
                            ></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.erziehungsberechtigter.email"
                                label="E-Mail"
                                :valdisabled="!brauchterziehungsberechtigten"
                                rules="required|email"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="
                                    ansuchen.erziehungsberechtigter.andereemail
                                "
                                label="weitere E-Mail"
                                rules="email"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="
                                    ansuchen.erziehungsberechtigter.telefon
                                "
                                label="Telefonnummer"
                                :valdisabled="!brauchterziehungsberechtigten"
                                rules="required|numeric"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="
                                    ansuchen.erziehungsberechtigter
                                        .anderestelefon
                                "
                                label="weitere Telefonnummer"
                                rules="numeric"
                                columns="3"
                            ></text-input>
                        </form-section>

                        <form-section
                            title="Angaben zum/zur Lehrenden"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                        >
                            <drop-down
                                :values="[
                                    { id: 865250001, name: 'Herr' },
                                    { id: 865250000, name: 'Frau' },
                                ]"
                                v-model="ansuchen.lehrperson.anrede"
                                label="Anrede"
                                rules="required"
                                columns="2"
                            ></drop-down>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.lehrperson.prefix"
                                label="Titel (vorangestellt)"
                                columns="2"
                            ></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.lehrperson.vorname"
                                label="Vorname"
                                rules="required"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.lehrperson.nachname"
                                label="Nachname"
                                rules="required"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.lehrperson.suffix"
                                label="Titel (nachgestellt)"
                                columns="2"
                            ></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.lehrperson.email"
                                label="E-Mail"
                                rules="required|email"
                                columns="3"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.lehrperson.telefon"
                                label="Telefonnummer"
                                rules="required|numeric"
                                columns="3"
                            ></text-input>
                        </form-section>

                        <form-section
                            title="Förderansuchen"
                            subtitle="zusätzliche Angaben"
                        >
                            <div class="col-span-6 sm:col-span-4">
                                <fieldset>
                                    <div class="mt-4">
                                        <check-box
                                            v-model="
                                                ansuchen.ansuchen
                                                    .bereitsgefoerdert
                                            "
                                            label="Ich habe bereits im aktuellen Schuljahr am Talenteprogramm teilgenommen."
                                        ></check-box>
                                    </div>
                                </fieldset>
                            </div>
                        </form-section>

                        <form-section title="Beilagen">
                            <file-upload
                                label="Meldebestätigung (nur wenn nicht Schülerin/Schüler an einer NÖ Musikschule)"
                                columns="4"
                                :maxSize="5"
                                @size-exceeded="onSizeExceeded"
                                @metadata="onMeldezettel"
                                @fileloaded="onMeldezettelLoad"
                            ></file-upload>

                            <file-upload
                                label="Urkunde des Wettbewerbs"
                                columns="4"
                                :maxSize="5"
                                @size-exceeded="onSizeExceeded"
                                @metadata="onWettbewerbErgebnis"
                                @fileloaded="onWettbewerbErgebnisLoad"
                            ></file-upload>
                        </form-section>

                        <form-section
                            title="Einverständniserklärung"
                            subtitle="Bitte lesen Sie aufmerksam die Bestimmungen"
                        >
                            <div class="col-span-6 sm:col-span-5">
                                 <legend
                                        class="text-base leading-6 font-medium text-gray-900 mb-2"
                                    >
                                        Information zum Talenteprogramm
                                    </legend>
                                <text-block
                                    :content="
                                        textbausteinfuer(
                                            'zustimmungen.talenteprogramm'
                                        )
                                    "
                                />
                            </div>
                        </form-section>

                        <form-section
                            title="Informationspflicht"
                            subtitle="gem. Art. 13 DSGVO"
                        >
                            <div class="col-span-6 sm:col-span-5">
                                <text-block
                                    :content="
                                        textbausteinfuer(
                                            'allgemein.informationspflicht'
                                        )
                                    "
                                />
                            </div>
                        </form-section>

                        <form-section
                            title="Bestätigung"
                            subtitle="Bitte geben Sie die E-Mailadresse an, an welche eine Eingangsbestätigung gesendet werden soll."
                        >
                            <text-input
                                v-model="ansuchen.bestaetigungsemail"
                                label="E-Mail"
                                rules="required|email"
                                columns="4"
                            ></text-input>
                             <div class="col-span-6">
                                <fieldset>
                                    <div class="mt-4">
                                        <check-box
                                            v-model="
                                                ansuchen.zustimmungen.hinweis
                                            "
                                            label="Hinweis"
                                            rules="required"
                                            :description="
                                                textbausteinfuer(
                                                    'zustimmungen.hinweis'
                                                )
                                            "
                                        ></check-box>
                                    </div>
                                </fieldset>
                            </div>
                        </form-section>

                        <div
                            class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                        >
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span
                                            class="inline-flex rounded-md shadow-sm"
                                        >
                                            <button
                                                @click="openSubmitModal()"
                                                type="button"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                            >
                                                Ansuchen absenden
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

        <transition name="fade">
            <div
                v-show="formbehaviour.showSendModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.showSendModal"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.showSendModal"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
                >
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Ansuchen absenden
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Nach dem Absenden können Sie das Ansuchen als PDF herunterladen. Bitte lassen Sie das Ansuchen unterschreiben und übermitteln dieses an uns.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                    >
                        <span
                            class="flex w-full rounded-md shadow-sm sm:col-start-2"
                        >
                            <button
                                @click="sendAnsuchen()"
                                type="button"
                                :disabled="formbehaviour.sending"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :class="[
                                    formbehaviour.sending ? ' bg-gray-300'
                                        : 'bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green'
                                ]"
                            >
                                Absenden
                            </button>
                        </span>
                        <span
                            class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
                        >
                            <button
                                @click="formbehaviour.showSendModal = false"
                                type="button"
                                :disabled="formbehaviour.sending"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 text-base leading-6 font-medium shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :class="[
                                    formbehaviour.sending ? ' bg-gray-300 text-white'
                                        : 'bg-white text-gray-700 focus:outline-none focus:border-blue-300 focus:shadow-outline hover:text-gray-500'
                                ]"
                            >
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.successful"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Bitte drucken Sie den Antrag aus und
                                    übermitteln ihn unterschrieben per E-Mail an
                                    das Musik &amp; Kunst Schulen Management
                                    Niederösterreich.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6">
                        <span class="flex w-full rounded-md shadow-sm">
                            <button
                                @click="generatePdf()"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Dokument herunterladen
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <div id="pdf"></div>
    </div>
</template>

<script>
import FormSection from '@/components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'

import TextInput from '@/components/inputs/TextInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

import FileUpload from '@/components/inputs/FileUpload.vue'

import * as JsPDF from 'jspdf'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        hash: {
            type: String,
            required: false,
        },
    },
    components: {
        TextInput,
        CheckBox,
        DropDown,
        FormSection,
        FormHeader,
        RadioButtonList,
        TextBlock,
        FileUpload,
    },
    data: function() {
        return {
            formbehaviour: {
                showSendModal: false,
                instrument: [],
                musikschulen: [],
                altersstufen: [],
                alertrequired: false,
                sending: false,
                successful: false,
            },
            formdata: {
                musikschule: [],
                wettbewerbe: [],
                faecher: [],
                altersgruppen: [],
                textbausteine: [],
            },
            ansuchen: {
                bestaetigungsemail: null,
                instrumentId: null,
                schueler: {
                    anrede: null,
                    vorname: null,
                    nachname: null,
                    geburtsdatum: null,
                    strasse: null,
                    plz: null,
                    ort: null,
                    email: null,
                    telefon: null,
                },
                musikschuleId: null,
                anderemusikschule: null,
                wettbewerb: {
                    wettbewerbId: null,
                    altersgruppeId: null,
                    ergebnis: null,
                    vorspielAm: null,
                    andererwettbewerb: null,
                    antrittals: null,
                    ensemblename: null,
                },
                erziehungsberechtigter: {
                    anrede: null,
                    vorname: '',
                    nachname: '',
                    prefix: '',
                    suffix: '',
                    email: '',
                    andereemail: '',
                    telefon: '',
                    anderestelefon: '',
                },
                lehrperson: {
                    anrede: null,
                    vorname: null,
                    nachname: null,
                    prefix: null,
                    suffix: null,
                    email: null,
                    telefon: null,
                },
                ansuchen: {
                    bereitsgefoerdert: false,
                },
                meldezettel: {
                    subject: 'Upload - Meldezettel',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
                wettbewerbErgebnis: {
                    subject: 'Upload - Wettbewerb',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
                zustimmungen: {
                    datenschutz: false,
                    hinweis: false,
                },
            },
        }
    },
    watch: {
        wettbewerbId() {
            if (this.ansuchen.wettbewerb.wettbewerbId) {
                this.fetchAltersgruppen(this.ansuchen.wettbewerb.wettbewerbId)
                this.fetchFaecher(this.ansuchen.wettbewerb.wettbewerbId)
            }
        },
        andererwettbewerb() {
            if (this.ansuchen.wettbewerb.andererwettbewerb) {
                this.fetchFaecher('e5e79512-6f79-ea11-bb90-000c29cb3d8b')
            }
        },
    },
    computed: {
        wettbewerbId() {
            return this.ansuchen.wettbewerb.wettbewerbId
        },
        andererwettbewerb() {
            return this.ansuchen.wettbewerb.andererwettbewerb
        },
        brauchterziehungsberechtigten: function() {
            if (!this.ansuchen.schueler.geburtsdatum) return true

            var parts = this.ansuchen.schueler.geburtsdatum.split('.')

            if (parts.length < 3) return true
            var parsed = new Date(
                parseInt(parts[2], 10),
                parseInt(parts[1], 10) - 1,
                parseInt(parts[0], 10)
            )

            if (!parsed) return true

            var ageDifMs = Date.now() - parsed
            var ageDate = new Date(ageDifMs) // miliseconds from epoch

            return Math.abs(ageDate.getUTCFullYear() - 1970) < 18
        },
    },
    created: function() {},
    methods: {
        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('talenteprogramm')
                .textbloecke()
            this.formdata.textbausteine = data
        },

        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },

        async fetchWettbewerbe() {
            const { data } = await this.service.wettbewerb.alle()
            this.formdata.wettbewerbe = data
        },

        async fetchFaecher(wettbewerbId) {
            const { data } = await this.service.wettbewerb
                .get(wettbewerbId)
                .faecher()
            this.formdata.faecher = data
        },

        async fetchAltersgruppen(wettbewerbId) {
            const { data } = await this.service.wettbewerb
                .get(wettbewerbId)
                .altersgruppen('1')
            this.formdata.altersgruppen = data
        },

        async sendAnsuchen() {
            if (this.formbehaviour.sending) {
                return;
            }
            
            try {
                this.formbehaviour.sending = true
                await this.service.formular.senden(
                    'talenteprogramm',
                    this.ansuchen
                )
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true
            } catch (error) {
                console.log(Object.keys(error), error.message)
            } finally {
                this.formbehaviour.sending = false
            }
        },

        openSubmitModal() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    window.scrollTo(0, 0)
                    this.formbehaviour.alertrequired = true
                    return
                }

                this.formbehaviour.showSendModal = true
            })
        },

        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found.content
        },

        onMeldezettel(file) {
            this.ansuchen.meldezettel.mimeType = file.type
            this.ansuchen.meldezettel.filename = file.name
        },

        onMeldezettelLoad(dataUri) {
            this.ansuchen.meldezettel.body = dataUri
        },

        onWettbewerbErgebnis(file) {
            this.ansuchen.wettbewerbErgebnis.mimeType = file.type
            this.ansuchen.wettbewerbErgebnis.filename = file.name
        },

        onWettbewerbErgebnisLoad(dataUri) {
            this.ansuchen.wettbewerbErgebnis.body = dataUri
        },

        onSizeExceeded(size) {
            alert(`Datei mit ${size}MB zu groß. (Maximal 5 MB)`)
        },

        generatePdf() {
            var doc = new JsPDF()

            let x = 20
            let y = 40

            doc.setFontType('normal')
            doc.setFontSize(11)

            const logo = require('@/assets/img/logo.jpg')
            var imgLogo = new Image()
            imgLogo.src = logo
            const footerlogo = require('@/assets/img/footerlogo.png')
            var imgFooter = new Image()
            imgFooter.src = footerlogo
            doc.addImage(imgLogo, 'PNG', 140, 5)
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.text('Seite 1 von 3', 17, 285, 'left')

            doc.text(x, y, 'An die: ')
            doc.text(
                x,
                y + 5,
                'MKM Musik & Kunst Schulen Management Niederösterreich GmbH'
            )
            doc.text(x, y + 10, 'Neue Herrengasse 10')
            doc.text(x, y + 15, '3100 St. Pölten')

            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(
                x,
                y + 40,
                'ANSUCHEN: Talenteprogramm ohne Strukturförderung'
            )

            y = 100
            doc.setFontType('bold')
            doc.text(x, y, 'Angaben zur Schülerin bzw. zum Schüler')
            doc.setFontSize(11)
            doc.setFontType('normal')
            doc.text(x, y + 6, 'Anrede:')
            doc.text(x, y + 12, 'Vorname:')
            doc.text(x, y + 18, 'Name:')
            doc.text(x, y + 24, 'Geburtsdatum:')
            doc.text(x, y + 30, 'Straße, Nr:')
            doc.text(x, y + 36, 'PLZ / Ort:')
            doc.text(x, y + 42, 'E-Mail:')
            doc.text(x, y + 48, 'Telefonnummer:')
            doc.text(x, y + 54, 'Musikschule:')
            doc.text(x, y + 60, 'Instrument:')

            doc.text(
                x + 30,
                y + 6,
                this.ansuchen.schueler.anrede == 865250001 ? 'Herr' : 'Frau'
            )
            doc.text(x + 30, y + 12, this.ansuchen.schueler.vorname || '')
            doc.text(x + 30, y + 18, this.ansuchen.schueler.nachname || '')
            doc.text(x + 30, y + 24, this.ansuchen.schueler.geburtsdatum || '')
            doc.text(x + 30, y + 30, this.ansuchen.schueler.strasse || '')
            doc.text(
                x + 30,
                y + 36,
                this.ansuchen.schueler.plz + ' ' + this.ansuchen.schueler.ort
            )
            doc.text(x + 30, y + 42, this.ansuchen.schueler.email || '')
            doc.text(x + 30, y + 48, this.ansuchen.schueler.telefon || '')
            doc.text(
                x + 30,
                y + 54,
                this.ansuchen.musikschuleId
                    ? this.formdata.musikschulen.find(
                          ms => ms.id == this.ansuchen.musikschuleId
                      ).name
                    : this.ansuchen.anderemusikschule || ''
            )
            doc.text(
                x + 30,
                y + 60,
                this.ansuchen.instrumentId
                    ? this.formdata.faecher.find(
                          fa => fa.id == this.ansuchen.instrumentId
                      ).name
                    : ''
            )

            y = 170
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Leistungsnachweis Wettbewerbsteilnahme')
            doc.setFontType('normal')
            doc.setFontSize(11)
            doc.text(x, y + 6, 'Wettbewerb:')
            doc.text(x, y + 12, 'Altersgruppe:')
            doc.text(x, y + 18, 'Wettbewerbsergebnis:')
            doc.text(x, y + 24, 'Datum des Vorspiels:')
            doc.text(x, y + 30, 'Antritt als:')
            if (this.ansuchen.wettbewerb.ensemblename)
                doc.text(x, y + 36, 'Ensemblename:')

            doc.text(
                x + 40,
                y + 6,
                this.ansuchen.wettbewerb.wettbewerbId != null && this.formdata.wettbewerbe.find(wb => wb.id == this.ansuchen.wettbewerb.wettbewerbId) != null
                    ? this.formdata.wettbewerbe.find(
                          wb => wb.id == this.ansuchen.wettbewerb.wettbewerbId
                      ).name
                    : this.ansuchen.wettbewerb.andererwettbewerb || ''
            )
            doc.text(
                x + 40,
                y + 12,
                this.ansuchen.wettbewerb.altersgruppeId != null && this.formdata.altersgruppen.find(ag => ag.id == this.ansuchen.wettbewerb.altersgruppeId) != null
                    ? this.formdata.altersgruppen.find(
                          ag => ag.id == this.ansuchen.wettbewerb.altersgruppeId
                      ).name
                    : '---'
            )
            doc.text(x + 40, y + 18, this.ansuchen.wettbewerb.ergebnis || '')
            doc.text(x + 40, y + 24, this.ansuchen.wettbewerb.vorspielAm || '')
            doc.text(
                x + 40,
                y + 30,
                this.ansuchen.wettbewerb.antrittals == 180730000
                    ? 'SolistIn'
                    : 'Ensemble'
            )
            doc.text(
                x + 40,
                y + 36,
                this.ansuchen.wettbewerb.ensemblename || ''
            )

            y = 245

            doc.setFontType('bold')
            doc.text(
                x + 130,
                y,
                this.ansuchen.ansuchen.bereitsgefoerdert ? 'JA' : 'NEIN'
            )
            doc.setFontType('normal')
            doc.text(
                x,
                y,
                'Ich habe bereits im aktuellen Schuljahr am Talenteprogramm teilgenommen:'
            )

            doc.addPage()
            doc.addImage(imgLogo, 'PNG', 140, 5)
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.text('Seite 2 von 3', 17, 285, 'left')

            y = 45
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Angaben zur Erziehungsberechtigten')
            doc.text(x, y + 6, 'bzw. zum Erziehungsberechtigten')
            doc.setFontSize(11)
            doc.setFontType('normal')
            doc.text(x, y + 12, 'Anrede:')
            doc.text(x, y + 18, 'Titel:')
            doc.text(x, y + 24, 'Vorname:')
            doc.text(x, y + 30, 'Name:')
            doc.text(x, y + 36, 'Suffix:')
            doc.text(x, y + 42, 'E-Mail 1:')
            doc.text(x, y + 48, 'E-Mail 2:')
            doc.text(x, y + 54, 'Telefon 1:')
            doc.text(x, y + 60, 'Telefon 2:')

            doc.text(
                x + 20,
                y + 12,
                this.ansuchen.erziehungsberechtigter.anrede == 865250001
                    ? 'Herr'
                    : 'Frau'
            )
            doc.text(
                x + 20,
                y + 18,
                this.ansuchen.erziehungsberechtigter.prefix || ''
            )
            doc.text(
                x + 20,
                y + 24,
                this.ansuchen.erziehungsberechtigter.vorname || ''
            )
            doc.text(
                x + 20,
                y + 30,
                this.ansuchen.erziehungsberechtigter.nachname || ''
            )
            doc.text(
                x + 20,
                y + 36,
                this.ansuchen.erziehungsberechtigter.suffix || ''
            )
            doc.text(
                x + 20,
                y + 42,
                this.ansuchen.erziehungsberechtigter.email || ''
            )
            doc.text(
                x + 20,
                y + 48,
                this.ansuchen.erziehungsberechtigter.andereEmail || ''
            )
            doc.text(
                x + 20,
                y + 54,
                this.ansuchen.erziehungsberechtigter.telefon || ''
            )
            doc.text(
                x + 20,
                y + 60,
                this.ansuchen.erziehungsberechtigter.anderesTelefon || ''
            )

            x = 110
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Angaben zur Lehrkraft')
            doc.setFontSize(11)
            doc.setFontType('normal')
            doc.text(x, y + 6, 'Anrede:')
            doc.text(x, y + 12, 'Titel:')
            doc.text(x, y + 18, 'Vorname:')
            doc.text(x, y + 24, 'Name:')
            doc.text(x, y + 30, 'Suffix:')
            doc.text(x, y + 36, 'E-Mail:')
            doc.text(x, y + 42, 'Telefon:')

            doc.text(
                x + 20,
                y + 6,
                this.ansuchen.lehrperson.anrede == 865250001 ? 'Herr' : 'Frau'
            )
            doc.text(x + 20, y + 12, this.ansuchen.lehrperson.prefix || '')
            doc.text(x + 20, y + 18, this.ansuchen.lehrperson.vorname || '')
            doc.text(x + 20, y + 24, this.ansuchen.lehrperson.nachname || '')
            doc.text(x + 20, y + 30, this.ansuchen.lehrperson.suffix || '')
            doc.text(x + 20, y + 36, this.ansuchen.lehrperson.email || '')
            doc.text(x + 20, y + 42, this.ansuchen.lehrperson.telefon || '')

            x = 20
            y = 117
            var paragraph =
                this.textbausteinfuer('zustimmungen.talenteprogramm')

            var lines = doc.splitTextToSize(paragraph, 170)
           
            doc.setFontType('normal')
            doc.text(x, y, lines)

            y = 216
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Beilagen')
            doc.setFontSize(11)
            doc.setFontType('normal')
            y = 219
            doc.circle(x + 2, y + 5, 2)
            doc.text(x + 10, y + 6, 'Meldebestätigung')
            doc.text(
                x + 10,
                y + 11,
                '(nur wenn nicht Schülerin bzw. Schüler an einer NÖ Musikschule)'
            )
            doc.circle(x + 2, y + 15, 2)
            doc.text(x + 10, y + 16, 'Urkunde des Wettbewerbs')
            doc.text(x + 10, y + 21, '')

            y = 258
            doc.text(x, y, '_________________________________')
            doc.text(x, y + 5, 'Unterschrift Schülerin bzw. Schüler')

            doc.text(x + 95, y, '_________________________________')
            doc.text(x + 95, y + 5, 'Unterschrift Erziehungsberechtige')

            doc.text(x, y + 14, '_________________________________')
            doc.text(x, y + 19, 'Unterschrift Lehrende')

            doc.addPage()
            doc.addImage(imgLogo, 'PNG', 140, 5)
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.text('Seite 3 von 3', 17, 285, 'left')

            x = 20
            y = 45
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Informationspflicht gem. Art. 13 DSGVO')
            doc.setFontType('normal')
            doc.setFontSize(10)
            paragraph =
                'Verantwortlicher: MKM Musik & Kunst Schulen Management Niederösterreich GmbH, 3100 St. Pölten, Neue Herrengasse 10, Telefon: +43 2742 9005 16880, Telefax: +43 2742 9005 16820, Webseite: www.mkmnoe.at, E-Mail: office@mkmnoe.at\r\n\r\nDatenschutzbeauftragter: Fabian Röper, MA MA, 3100 St. Pölten, Hypogasse 1/2.Stock, Telefon: +43 2742 9005 16895, E-Mail: datenschutz@mkmnoe.at\r\n\r\nZweck der Verarbeitung und Rechtsgrundlage: Ihre personenbezogenen Daten (Schüler: Vorname, Nachname, Instrument, Geburtsdatum, PLZ, Ort, Telefonnummer, E-Mail Adresse, Wettbewerbsergebnis, Altersgruppe, Meldebestätigung; Lehrende/Ensembleleitung: Titel, Vorname, Nachname, E-Mail, Telefonnummer und ggfs. Erziehungsberechtigte: Titel, Vorname, Nachname, Telefonnummer, E-Mail Adresse) werden zum Zweck der Anmeldung zum Talenteprogramm bzw. der Organisation und Durchführung des Talenteprogramms (z.B. Meisterkurse, Workshops, etc.) verarbeitet.\r\n\r\nDie Daten werden intern von den zuständigen Mitarbeiterinnen und Mitarbeitern, welche mit der Abwicklung des Talenteprogramms betraut sind, verarbeitet und nur dann intern oder an Dritte weitergegeben, wenn dies zum Zweck der Vertragsabwicklung erforderlich ist, oder, im berechtigten Interesse der Verantwortlichen gem. Art 6 Abs 1 lit f DSGVO liegt, oder Sie der Verarbeitung der Daten davor zugestimmt haben.\r\n\r\nDie Verarbeitung erfolgt aufgrund der vertraglichen Verpflichtungen und Notwendigkeiten, welche sich aus der Aufnahme in das Talenteprogramm ergeben, bzw. aufgrund einer Vertragsanbahnung bzw. zur Vertragserfüllung gem. Art 6 Abs 1 lit b DSGVO, aufgrund rechtlicher Verpflichtungen des Verantwortlichen gem. Art 6 Abs 1 lit c DSGVO oder aufgrund des berechtigten Interesses der Verantwortlichen gem. Art 6 Abs 1 lit f DSGVO.\r\n\r\nSpeicherdauer: Die Speicherung der Daten erfolgt für die Dauer der Teilnahme am Talenteprogramm bzw. aufgrund gesetzlicher Pflichten im Ausmaß von jedenfalls 10 Jahren.\r\n\r\nRechte der betroffenen Personen: Auskunft und Berichtigung und Einschränkung der Verarbeitung der personenbezogenen Daten. Weiters haben Sie das Recht auf Beschwerde bei der Aufsichtsbehörde (Österreichische Datenschutzbehörde, Wickenburggasse 8, 1080 Wien, dsb@dsb.gv.at). Nähere Informationen finden Sie in unserer Datenschutzerklärung unter https://www.mkmnoe.at/datenschutz.'
            lines = doc.splitTextToSize(paragraph, 175)
            doc.text(x, y + 7, lines)

            doc.save('ansuchen.pdf')
        },
        async fetchHashAndGeneratePdf(hash) {
            const { data } = await this.service.formular.byhash(hash)
            this.ansuchen = data
            await this.fetchFaecher(this.ansuchen.wettbewerb.andererwettbewerb ? 'e5e79512-6f79-ea11-bb90-000c29cb3d8b' : this.ansuchen.wettbewerb.wettbewerbId) 
            await this.fetchAltersgruppen(this.ansuchen.wettbewerb.andererwettbewerb ? 'e5e79512-6f79-ea11-bb90-000c29cb3d8b' : this.ansuchen.wettbewerb.wettbewerbId) 
            this.generatePdf()
        },
        async initData() {
            await this.fetchMusikschulen()
            await this.fetchTextBausteine()
            await this.fetchWettbewerbe()
        },
    },
    created() {
        this.initData().then(() => {
            if (this.hash) {
                this.fetchHashAndGeneratePdf(this.hash)
            }
        })
    },
    beforeDestroy() {},
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
